import React, {Component} from 'react';
import Modal from 'react-responsive-modal';
import classNames from 'classnames';
import "../notations";


export class Segunda extends Component {
    constructor(props) {
        super(props);
        this.state = { open: false};
    }

    openModal = () => {
        this.setState({ open: true });
    };

    closeModal = () => {
        this.setState({ open: false });
    };

    selectOption = (input, value) => {
        input.onChange(value);
        this.closeModal();
    };

    render() {
        const { input, meta: { touched, error }, title } = this.props;
        const { open } = this.state;
        const invalid = touched && error;

        let fi = 0.00;
        const ff = 0.00;

        let ci = 0;
        const cf = 4;

        let columnas = [];

        for(fi;fi<=ff;fi++){
            ci = 0;
            let fila = [];
            for(ci;ci<=cf;ci++){
                const cantidad = fi + (ci*0.25);
                fila.push(cantidad.toFixed(2))
            }
            columnas.push(fila);
        }


        return (
            <React.Fragment>
                <Modal open={open} onClose={this.closeModal} >
                    <div className="text-center">
                        <h2 className="border-bottom">{title}</h2>
                    </div>
                    <table id="notations-table-modal">
                        <tr>
                        </tr>
                        <tbody>
                        {columnas.map(columna=>(
                            <tr key={columna}>
                                {columna.map(fila=>(
                                    <React.Fragment key={fila}>
                                    {fila <=0.75 &&
                                    <td key={fila}>
                                        <div className="radio">
                                            <label htmlFor="service_type" className="radio-inline mr-5 d-flex align-items-center"
                                                onClick={() => this.selectOption(input, fila)}>
                                                <input type={"radio"} value={fila} {...input} onChange={() => this.selectOption(input, fila)}
                                                    className={classNames('form-control', { 'is-invalid': invalid })} />
                                                &nbsp;{fila}
                                            </label>
                                        </div>
                                    </td>
                                    }
                                    </React.Fragment>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-center align-items-center mt-4">
                        <div
                            className="btn btn-secondary mx-4"
                            onClick={() => {
                                input.onChange(undefined);
                                this.closeModal();
                            }}>
                            Cancelar
                        </div>
                    </div>
                </Modal>
                <span className="form-control text-center" onClick={this.openModal} >{input.value}</span>
            </React.Fragment>
        );
    }
}
